import "./bootstrap";
import { createApp } from "vue/dist/vue.esm-bundler";
import { createPinia } from "pinia";
import { useGlobalStore } from "@/stores/global";
import router from "./router";

const pinia = createPinia();
const app = createApp({}).use(router).use(pinia);
const global = useGlobalStore();

global.getEventStages();

app.mount("#logi-adaptive");
